import { useZodFormContext } from '@repo/hooks/useZodFormContext';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '../../ui/dropdown-menu';

export interface DateRangePreset {
  label: string;
  value: () => void;
}

const DateRangePresets = () => {
  const form = useZodFormContext();
  const today = new Date();

  const oneWeekAgoDate = new Date();
  oneWeekAgoDate.setDate(today.getDate() - 7);

  const oneMonthAgoDate = new Date();
  oneMonthAgoDate.setDate(today.getDate() - 30);

  const twoMonthsAgoDate = new Date();
  twoMonthsAgoDate.setDate(today.getDate() - 60);

  const oneYearAgoDate = new Date();
  oneYearAgoDate.setDate(today.getDate() - 365);

  // SET DATE RANGES
  const ranges: DateRangePreset[] = [
    {
      label: 'Past 7 days',
      value: setPastWeek,
    },
    {
      label: 'Past 30 days',
      value: setPastMonth,
    },
    {
      label: 'Past 60 days',
      value: setPastTwoMonths,
    },
    {
      label: 'Past 365 days',
      value: setPastYear,
    },
  ];

  function setPastWeek() {
    form?.setValue('start', oneWeekAgoDate, {
      shouldDirty: true,
    });
    form?.setValue('end', today, {
      shouldDirty: true,
    });
  }

  function setPastMonth() {
    form?.setValue('start', oneMonthAgoDate, {
      shouldDirty: true,
    });
    form?.setValue('end', today, {
      shouldDirty: true,
    });
  }

  function setPastTwoMonths() {
    form?.setValue('start', twoMonthsAgoDate, {
      shouldDirty: true,
    });
    form?.setValue('end', today, {
      shouldDirty: true,
    });
  }

  function setPastYear() {
    form?.setValue('start', oneYearAgoDate, {
      shouldDirty: true,
    });
    form?.setValue('end', today, {
      shouldDirty: true,
    });
  }

  if (!form) {
    return <></>;
  }

  return (
    <div className="relative mt-[26px]">
      <DropdownMenu>
        <DropdownMenuTrigger
          className="relative px-2 w-full text-left rounded-md border appearance-none disabled:bg-transparent dark:text-blue-100 py-[9px] bg-grey-100 border-grey-500 placeholder:text-grey-500 dark:placeholder:text-grey-400 dark:bg-blue-900 dark:border-grey-600 focus:border-blue-500 dark:focus:border-blue-300 focus:outline-none"
        >
          Select Range{' '}
          <span className="absolute top-1/4 -translate-y-[1px] flex items-center h-full pointer-events-none right-[9px] dark:text-blue-100 text-grey-1000 material-symbols-outlined">
            expand_more
          </span>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          className="w-(--radix-dropdown-menu-trigger-width) p-1 rounded-md bg-grey-100 dark:bg-blue-900 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
        >
          {ranges.map((range, i) => (
            <DropdownMenuItem
              key={i}
              onSelect={() => range?.value()}
              className="flex w-full items-center rounded-md p-2 dark:text-blue-100 text-grey-1000 hover:bg-blue-200 hover:dark:bg-blue-800 focus:bg-blue-200 focus:dark:bg-blue-800"
            >
              {range.label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default DateRangePresets;
